export enum HydrationStrategyEnum {
    IDLE = "idle",
    VIEWPORT = "viewport",
    INTERACTION = "interaction",
    HOVER = "hover",
    IMMEDIATE = "immediate",
    TIMER = "timer",
  }